import PropTypes from 'prop-types';
import { Suspense } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { SplashScreen } from 'src/components/loading-screen';
import ClientBootstrap from 'src/redux/client/ClientBootstrap';

import { clientPersistor, clientStore } from 'src/redux/clientStore';

export default function ClientStoreProvider({ children }) {
  return (
    <Provider store={clientStore}>
      <PersistGate persistor={clientPersistor}>
        <Suspense fallback={<SplashScreen />}>
          <ClientBootstrap>{children}</ClientBootstrap>
        </Suspense>
      </PersistGate>
    </Provider>
  );
}

ClientStoreProvider.propTypes = {
  children: PropTypes.node,
};
